module.exports = __webpack_public_path__ + "static/media/trash.0f75095d.svg";